import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { busyWhile } from "lib/@components/busy/busy-while"
import { retireSchedules } from "routes/schedule/my-schedules/my-custom-schedules/controller/retire-schedules"
import { waitForScheduleRefresh } from "routes/schedule/lib/wait-for-schedule-refresh"

export function ReinstateRetired() {
    const { target } = useBoundContext()
    return <ContextMenuItem icon="ix:restore" label="Reinstate" onClick={reinstate} data-cy="menu-item-reinstate" />

    async function reinstate() {
        await busyWhile(() => retireSchedules(false, [target._id]), "Reinstating", waitForScheduleRefresh)
    }
}
